/* eslint-disable */
import "./athleteOverview.scss";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getAthleteHistoricalGait,
  getAthleteHistoricalLoad,
  getAthleteHistoricalGroundContact,
  selectAthlete,
  getAthleteHistoricalRawAggSessions,
} from "store/athleteSlice";
import { useCallback, useEffect, useState, useRef } from "react";
import { getSessionList } from "store/sessionListSlice";
import { resetAllData } from "store/sessionSlice";
import { useCheckForJumpData } from "../hooks/useCheckForJumpData";
import { selectUserData } from "store/userSlice";
import PlayerActivityDetails from "components/users/PlayerActivityDetails2";
import { setGraphModal, setSelectedSessionId } from "store/playerActivitySlice";
import { selectUser, userState } from "store/authSlice";
import { updateUserLayoutAPI } from "api/user";
import {
  LoadCustomTooltip,
  CustomLineTooltip,
  CustomAsymLineTooltip,
} from "./athleteOverviewHelpers/athleteOverviewCustomTooltips";
import AthleteOverviewMainTable from "./athleteOverviewTable/AthleteOverviewMainTable";
import AthleteOverviewChart from "./athleteOverviewCharts/AthleteOverviewChart";
import moment from "moment";
import AthleteOverviewSummaryCard from "./athleteOverviewSummaryCard/AthleteOverviewSummaryCard";
import Polygon from "../icons/downArrow";
import MainButton from "../reuseableButtonComponent/MainButton";
import BookmarkIcon from "../icons/bookmarkIcon";
import MainModal from "../mainModal/MainModal";
import EscapeIcon from "components/nav-components/nav-icons/escape-icon";
import Settings from "../icons/settings";
import SwapIcon from "../icons/swapIcon";
import { nanoid } from "@reduxjs/toolkit";
import CounterOrSelector from "components/counter-or-selector/CounterOrSelector";
import { DateRangePicker } from "react-dates";
import { NEW_RIGHT_COLOR } from "utils/constant";
import DownloadIcon from "../icons/downloadIcon";
import MainTooltip from "../mainTooltip/MainTooltip";

function accessNestedProperty(obj, keyString) {
  return keyString.split(".").reduce((acc, key) => acc && acc[key], obj);
}

//hook for click off filter modal
const useOutsideAlerted = (ref, setToggler) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setToggler(false);
      }
    };

    //bind to event
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
};

//table cell component
const CustomizeableTableCell = ({
  value,
  bilateral = false,
  leftValue,
  rightValue,
  fullDataSet,
  appearanceOption,
  dataSetIndex,
  measurementUnit,
}) => {
  const getColourFunction = (arr, value, returnType, key, multi = false) => {
    const arrayOfColours = [
      `rgba(52, 152, 219,${calculatePercentage(arr, value, returnType)})`, //rgba(52, 152, 219,1)
      `rgba(6, 82, 221,${calculatePercentage(arr, value, returnType)})`, //rgba(6, 82, 221,1.0)
      `rgba(217, 128, 250,${calculatePercentage(arr, value, returnType)})`, //rgba(217, 128, 250,1.0)
      `rgba(247, 159, 31,${calculatePercentage(arr, value, returnType)})`, //rgba(247, 159, 31,1.0)
      `rgba(225, 95, 65,${calculatePercentage(arr, value, returnType)})`, //rgba(225, 95, 65,1.0)
      `rgba(114, 170, 65,${calculatePercentage(arr, value, returnType)})`, //rgba(114, 170, 65, 1)
      `rgba(86, 42, 165,${calculatePercentage(arr, value, returnType)})`, //rgba(86, 42, 165, 1)
      `rgba(119, 139, 235,${calculatePercentage(arr, value, returnType)})`, //rgba(119, 139, 235,1.0)
      `rgba(245, 205, 121,${calculatePercentage(arr, value, returnType)})`, //rgba(245, 205, 121,1.0)
      `rgba(120, 224, 143,${calculatePercentage(arr, value, returnType)})`, //rgba(120, 224, 143,1.0)
      `rgba(205, 132, 241,${calculatePercentage(arr, value, returnType)})`, //rgba(205, 132, 241,1.0)
      `rgba(108, 92, 231,${calculatePercentage(arr, value, returnType)})`, //rgba(108, 92, 231,1.0)
      `rgba(250, 177, 160,${calculatePercentage(arr, value, returnType)})`, //rgba(250, 177, 160,1.0)
      `rgba(85, 239, 196,${calculatePercentage(arr, value, returnType)})`, //rgba(85, 239, 196,1.0)
      `rgba(229, 80, 57,${calculatePercentage(arr, value, returnType)})`, //rgba(229, 80, 57,1.0)
    ];

    if (multi === false) {
      return arrayOfColours[0];
    } else {
      return arrayOfColours[key];
    }
  };

  const dataset =
    bilateral === false
      ? fullDataSet.map((item) => item.value)
      : fullDataSet.flatMap((item) => [item.leftValue, item.rightValue]);

  function calculatePercentage(arr, value, returnType = "percentage") {
    if (arr?.length === 0) {
      //console.log("The array cannot be empty.");
      return;
    }

    const newArr = arr.map((value) => (value > 0 ? value : value * -1));

    const minVal = Math.min(...newArr);
    const maxVal = Math.max(...newArr);

    if (minVal === maxVal) {
      //console.log("All values in the array are the same.");
      return returnType === "percentage" ? "100%" : 1;
    }

    // Normalize value
    let normalizedValue = (value - minVal) / (maxVal - minVal);

    // Ensure minimum percentage is 10%
    let percentage = 10 + normalizedValue * 90;

    // Clamp to 100%
    percentage = Math.min(percentage, 100);

    if (returnType === "percentage") {
      return percentage.toFixed(0) + "%";
    } else if (returnType === "decimal") {
      return (percentage / 100).toFixed(1);
    } else {
      // console.log(
      //   "Invalid return type specified. Use 'percentage' or 'decimal'."
      // );
      return;
    }
  }

  return (
    <>
      {appearanceOption === 0 ? (
        <div className="customizeable_table_cell">
          {!bilateral ? (
            <div className="single_value">
              {measurementUnit && measurementUnit?.includes("%") ? (
                <p>{value > 0 ? value + " L" : value * -1 + " R"}</p>
              ) : (
                <p>{value}</p>
              )}
            </div>
          ) : (
            ""
          )}
          {bilateral ? (
            <div className="multiple_value">
              <div className="values">
                <div>{leftValue}L</div>
                <div>{rightValue}R</div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : null}

      {appearanceOption === 1 ? (
        <div className="customizeable_table_cell">
          {!bilateral ? (
            <div className="single_value_bar">
              {measurementUnit && measurementUnit?.includes("%") ? (
                value > 0 ? (
                  <div>
                    {value} <span className="span_left">{"L"}</span>
                  </div>
                ) : (
                  <div>
                    {value * -1} <span className="span_right">{" R"}</span>
                  </div>
                )
              ) : (
                <p>{value}</p>
              )}
              <div
                className={`${
                  measurementUnit && measurementUnit?.includes("%")
                    ? value > 0
                      ? "bar_left"
                      : "bar_right"
                    : "bar"
                }`}
                style={{ width: calculatePercentage(dataset, value) }}
              ></div>
            </div>
          ) : (
            ""
          )}
          {bilateral ? (
            <div className="multiple_value">
              <div className="values">
                <div className="left_value">
                  {leftValue}
                  <span>L</span>
                </div>
                <div className="right_value">
                  {rightValue}
                  <span>R</span>
                </div>
              </div>
              <div
                className="bar_left"
                style={{ width: calculatePercentage(dataset, leftValue) }}
              ></div>
              <div
                className="bar_right"
                style={{ width: calculatePercentage(dataset, rightValue) }}
              ></div>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : null}
      {appearanceOption === 2 ? (
        <div
          className="customizeable_table_cell"
          style={
            !bilateral
              ? {
                  backgroundColor: getColourFunction(
                    dataset,
                    value,
                    "decimal",
                    dataSetIndex,
                    false
                  ),
                }
              : {
                  backgroundColor: getColourFunction(
                    dataset,
                    (Number(leftValue) + Number(rightValue) / 2).toFixed(2),
                    "decimal",
                    dataSetIndex,
                    false
                  ),
                }
          }
        >
          {!bilateral ? (
            <div className="single_value">
              {" "}
              {measurementUnit && measurementUnit?.includes("%") ? (
                <p>{value > 0 ? value + " L" : value * -1 + " R"}</p>
              ) : (
                <p>{value}</p>
              )}
            </div>
          ) : (
            ""
          )}
          {bilateral ? (
            <div className="multiple_value">
              <div className="values">
                <div>{leftValue}L</div>
                <div>{rightValue}R</div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : null}
      {appearanceOption === 3 ? (
        <div
          className="customizeable_table_cell"
          style={
            !bilateral
              ? {
                  backgroundColor: getColourFunction(
                    dataset,
                    value,
                    "decimal",
                    dataSetIndex,
                    true
                  ),
                }
              : {
                  backgroundColor: getColourFunction(
                    dataset,
                    (Number(leftValue) + Number(rightValue) / 2).toFixed(2),
                    "decimal",
                    dataSetIndex,
                    true
                  ),
                }
          }
        >
          {!bilateral ? (
            <div className="single_value">
              {" "}
              {measurementUnit && measurementUnit?.includes("%") ? (
                <p>{value > 0 ? value + " L" : value * -1 + " R"}</p>
              ) : (
                <p>{value}</p>
              )}
            </div>
          ) : (
            ""
          )}
          {bilateral ? (
            <div className="multiple_value">
              <div className="values">
                <div>{leftValue}L</div>
                <div>{rightValue}R</div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : null}
    </>
  );
};

const TagsSelectionModalBody = ({
  uniqueArrayOfTags,
  selectedTags,
  handleTagClick,
}) => {
  const [searchText, setSearchText] = useState("");

  return (
    <div className="tags_selection_modal_container">
      <div className="tag_container_heading">
        <h3>Bookmark Sessions</h3>
        <p>
          Selecting a Tag from the list below will highlight points on the
          graphs below that are associated with the selected tag.
        </p>
      </div>
      <div className="tag_section_search">
        <input
          id="tags_search"
          name="tags_search"
          type="text"
          placeholder="Search..."
          autoComplete="off"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
      <div className="tag_sction_tag_container">
        {uniqueArrayOfTags
          .filter((tag) =>
            tag.tag
              .split(" ")
              .join("")
              .toLocaleLowerCase()
              .includes(searchText.split(" ").join("").toLocaleLowerCase())
          )
          .map((tag) => (
            <div
              className={`modal_tag ${
                selectedTags.includes(tag.TID) ? "modal_tag_active" : ""
              }`}
              key={tag.TID}
              onClick={() => handleTagClick(tag.TID)}
            >
              <p>{tag.tag}</p>
              {selectedTags.includes(tag.TID) ? (
                <div className="remove_icon">
                  <EscapeIcon />
                </div>
              ) : null}
            </div>
          ))}
        {uniqueArrayOfTags.length === 0 ? (
          <p className="tags_warning">
            No Tags have been assigned to any of this athletes sessions.
          </p>
        ) : (
          ""
        )}
        {uniqueArrayOfTags.length > 0 &&
        uniqueArrayOfTags.filter((tag) =>
          tag.tag
            .split(" ")
            .join("")
            .toLocaleLowerCase()
            .includes(searchText.split(" ").join("").toLocaleLowerCase())
        ).length === 0 ? (
          <p className="tags_warning">
            There are no tags by that name assigned to this athlete.
          </p>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

//modal settings component
const TableSettingsModalBody = ({
  allMetrics,
  selectedMetricsForToggleState,
  setSelectedMetricsForToggleState,
  disabledMetrics,
  setDisabledMetrics,
  appearanceSelected,
  setAppearanceSelected,
}) => {

  const allMetricsNamedArray = allMetrics.map((metric) => metric.metric);

  const demoDataArray = [
    [{ value: 26.55 }, { value: 41.32 }, { value: 80.98 }],
    [{ value: 5.37 }, { value: 1.52 }, { value: 25.4 }],
    [{ value: 29.87 }, { value: 30.14 }, { value: 34.19 }],
    [{ value: 1.88 }, { value: 2.65 }, { value: 3.1 }],
    [{ value: 2.02 }, { value: 3.1 }, { value: 5.3 }],
  ];

  const options = [
    "Number-only",
    "Bar",
    "Colour (Single)",
    "Colour (Multiple)",
  ];

  const [showingMetricSettings, setShowingMetricSettings] = useState(true);

  const handleTabClick = (whichTab) => {
    if (whichTab === "metric" && showingMetricSettings === false) {
      setShowingMetricSettings(true);
    }

    if (whichTab === "appearance" && showingMetricSettings === true) {
      setShowingMetricSettings(false);
    }
  };

  const handleMetricClick = (metric, whichContainer) => {
    if (whichContainer === "displayed") {
      if (!selectedMetricsForToggleState.displayedMetrics.includes(metric)) {
        setSelectedMetricsForToggleState((prevMetrics) => ({
          ...prevMetrics,
          displayedMetrics: [...prevMetrics.displayedMetrics, metric],
        }));
      }
    }
    if (selectedMetricsForToggleState.displayedMetrics.includes(metric)) {
      setSelectedMetricsForToggleState((prevMetrics) => ({
        ...prevMetrics,
        displayedMetrics: prevMetrics.displayedMetrics.filter(
          (m) => m !== metric
        ),
      }));
    }

    if (whichContainer === "hidden") {
      if (!selectedMetricsForToggleState.hiddenMetrics.includes(metric)) {
        setSelectedMetricsForToggleState((prevMetrics) => ({
          ...prevMetrics,
          hiddenMetrics: [...prevMetrics.hiddenMetrics, metric],
        }));
      }
    }
    if (selectedMetricsForToggleState.hiddenMetrics.includes(metric)) {
      setSelectedMetricsForToggleState((prevMetrics) => ({
        ...prevMetrics,
        hiddenMetrics: prevMetrics.hiddenMetrics.filter((m) => m !== metric),
      }));
    }
  };

  const handleMetricSwap = () => {
    if (selectedMetricsForToggleState.displayedMetrics.length > 0) {
      setDisabledMetrics((prev) => [
        ...prev,
        ...selectedMetricsForToggleState.displayedMetrics,
      ]);
    }

    if (selectedMetricsForToggleState.hiddenMetrics.length > 0) {
      setDisabledMetrics((prev) => {
        const updatedPrev = prev.filter(
          (metric) =>
            !selectedMetricsForToggleState.hiddenMetrics.includes(metric)
        );

        return [...updatedPrev];
      });
    }
    setSelectedMetricsForToggleState({
      hiddenMetrics: [],
      displayedMetrics: [],
    });
  };

  function onChange(i) {
    if (appearanceSelected !== i) {
      setAppearanceSelected(i);
    }
  }

  return (
    <div className="table_settings_modal_body_container">
      <div className="table_settings_modal_tabs">
        <div
          className={`table_settings_modal_metrics_tab ${
            showingMetricSettings ? "active_modal_tab" : ""
          }`}
          onClick={() => handleTabClick("metric")}
        >
          <p>
          Metrics
          </p>
        </div>
        <div
          className={`table_settings_modal_metrics_tab ${
            !showingMetricSettings ? "active_modal_tab" : ""
          }`}
          onClick={() => handleTabClick("appearance")}
        >
          <p>
          Appearance
          </p>
        </div>
      </div>
      <div className="table_settings_modal_body">
        {showingMetricSettings ? (
          <div className="table_settings_modal_metrics_body">
            <div className="table_settings_modal_metrics table_settings_modal_metrics_hidden">
              <div className="table_settings_section_heading">
                Hidden Metrics
              </div>
              <div className="modal_metrics_container hidden_metrics_container">
                {disabledMetrics.map((metric) => (
                  <div
                    className={`modal_metric ${
                      selectedMetricsForToggleState.hiddenMetrics.includes(
                        metric
                      )
                        ? "modal_metric_selected"
                        : ""
                    }`}
                    key={nanoid()}
                    onClick={() => handleMetricClick(metric, "hidden")}
                  >
                    {metric}
                  </div>
                ))}
              </div>
            </div>
            <div className="table_settings_modal_metrics_swapper">
              <div
                className={`swap_metrics_button ${
                  selectedMetricsForToggleState.displayedMetrics.length > 0 ||
                  selectedMetricsForToggleState.hiddenMetrics.length > 0
                    ? "swap_metrics_button_clickable"
                    : ""
                }`}
                onClick={() => {
                  selectedMetricsForToggleState.displayedMetrics.length > 0 ||
                  selectedMetricsForToggleState.hiddenMetrics.length > 0
                    ? handleMetricSwap()
                    : "";
                }}
              >
                <SwapIcon
                  size={24}
                  fillOpacity={
                    selectedMetricsForToggleState.displayedMetrics.length > 0 ||
                    selectedMetricsForToggleState.hiddenMetrics.length > 0
                      ? "1"
                      : "0.7"
                  }
                />
              </div>
            </div>
            <div className="table_settings_modal_metrics table_settings_modal_metrics_shown">
              <div className="table_settings_section_heading">
                Displayed Metrics
              </div>
              <div className="modal_metrics_container displayed_metrics_container">
                {allMetricsNamedArray.map((metric) => {
                  if (!disabledMetrics.includes(metric)) {
                    return (
                      <div
                        className={`modal_metric ${
                          selectedMetricsForToggleState.displayedMetrics.includes(
                            metric
                          )
                            ? "modal_metric_selected"
                            : ""
                        }`}
                        key={nanoid()}
                        onClick={() => handleMetricClick(metric, "displayed")}
                      >
                        {metric}
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        ) : null}
        {!showingMetricSettings ? (
          <div className="table_settings_modal_appearance_body">
            <div className="table_settings_appearance_section">
              <div className="section_title">Table Appearance</div>
              <div className="appearance_section_actions">
                {options.map((o, i) => (
                  <div className="option" key={nanoid()}>
                    <label key={i}>
                      <input
                        id="tag-appearance-option"
                        name="tag-appearance-option"
                        type="checkbox"
                        autoComplete="off"
                        checked={i === appearanceSelected}
                        onChange={() => onChange(i)}
                      />
                      <p>{o}</p>
                      <span className="checkmark"></span>
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <div className="table_settings_preview_section">
              <div className="section_title">Table Appearance</div>
              <div className="preview_section_table">
                {demoDataArray.map((group, index) => (
                  <div className="section_table_row" key={nanoid()}>
                    {group.map((cell) => (
                      <div className="section_table_cell" key={nanoid()}>
                        <CustomizeableTableCell
                          value={cell.value}
                          fullDataSet={group}
                          appearanceOption={appearanceSelected}
                          dataSetIndex={index}
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

const AthleteOverview2 = (props) => {
  const {
    athleteID,
    handleLoadClick,
    athlete,
    actions,
    downloadButtonClicked,
    isDownloading,
    handleSessionAveragedClick,
  } = props;

  const placeholderObject = [
    {
      summaryTitle: "Gait Summary",
      summaryType: "cards",
      summaryFor: "gait",
    },
    {
      summaryTitle: "Plyometrics Summary",
      summaryType: "cards",
      summaryFor: "plyometrics",
    },
    {
      summaryTitle: "Athlete Performance",
      summaryType: "chart",
      summaryFor: "overview",
    },
  ];

  const dispatch = useDispatch();
  const checkForJumpData = useCheckForJumpData();
  const { graphModal, sessionList, selectedSessionId, session } = useSelector(
    (state) => ({
      graphModal: state.playerActivity.graphModal,
      selectedSessionId: state.playerActivity.selectedSessionId,
      sessionList: state.sessionList,
      session: state.session,
    })
  );

  const mode = useSelector((state) => state.theme.mode)

  const userData = useSelector(selectUserData);

  const loggedUserData = useSelector(userState);

  // State declaration
  const [filterDate, setFilterDate] = useState({
    startDate: null,
    endDate: null,
  });

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);
  useOutsideAlerted(dropdownRef, setDropdownOpen);

  const [disabledMetrics, setDisabledMetrics] = useState([]);

  //table metrics
  const [numberOfLatestSessions, setNumberOfLatestSessions] = useState(8);
  const [filteringMethod, setFilteringMethod] = useState({
    latestSessions: false,
    presetRange: false,
    dateRange: true,
  });
  const [rangeFiltering, setRangeFiletering] = useState({
    number: 1,
    selected: "Day",
    selections: ["Day", "Week", "Month", "Year"],
  });
  const [focusedInput, setFocusedInput] = useState("startDate");
  const [focusedInput2, setFocusedInput2] = useState("startDate");
  const [overviewMetricData, setOverviewMetricData] = useState([]);
  const [maxMinAvg, setMaxMinAvg] = useState("max");

  //loading state
  const [isLoading, setIsLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(Date.now());
  const timeoutRef = useRef(null);

  //tags selected state
  const [selectedTags, setSelectedTags] = useState([]);
  const [filteringByTags, setFilteringByTags] = useState([]);
  const [uniqueArrayOfTags, setUniqueArrayOfTags] = useState([]);

  //raw data state
  const [rawDataState, setRawDataState] = useState({});
  const [fullRawDataState, setFullRawDataState] = useState({});

  //setting number of columns for grid display, based on number of cards and screen width
  const [columns, setColumns] = useState(placeholderObject.length);

  const [selectedMetricsForToggleState, setSelectedMetricsForToggleState] =
    useState({
      hiddenMetrics: [],
      displayedMetrics: [],
    });

  const [appearanceSelected, setAppearanceSelected] = useState(0);

  const [toggleCards, setToggleCards] = useState(false);

  const [filterToggleModal, setFilterToggleModal] = useState(false);

  const filterModalRef = useRef(null);
  useOutsideAlerted(filterModalRef, setFilterToggleModal);

  const [tagsSearch, setTagsSearch] = useState("");
  //c

  useEffect(() => {
    const updateColumns = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 425) {
        setColumns(1); // For very small screens
      } else if (windowWidth <= 820) {
        setColumns(Math.ceil(placeholderObject.length / 2)); // For medium screens
      } else {
        setColumns(placeholderObject.length); // For larger screens
      }
    };

    // Run on mount
    updateColumns();

    // Add window resize listener
    window.addEventListener("resize", updateColumns);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("resize", updateColumns);
    };
  }, [placeholderObject.length]);

  useEffect(() => {
    const localStorageData = JSON.parse(
      localStorage.getItem("userLayout")
    ).athleteOverview;
    if (
      localStorageData &&
      localStorageData?.hasOwnProperty("numberOfLatestSessions")
    ) {
      setNumberOfLatestSessions(localStorageData.numberOfLatestSessions);
    }
    if (localStorageData && localStorageData?.hasOwnProperty("maxMinAvg")) {
      setMaxMinAvg(localStorageData.maxMinAvg);
    }
    if (localStorageData?.hasOwnProperty("filteringMethod")) {
      setFilteringMethod(localStorageData.filteringMethod);
    }
    if (
      localStorageData &&
      localStorageData?.hasOwnProperty("rangeFiltering")
    ) {
      setRangeFiletering(localStorageData.rangeFiltering);
    }
    if (
      localStorageData &&
      localStorageData?.hasOwnProperty("disabledMetrics")
    ) {
      setDisabledMetrics(localStorageData.disabledMetrics);
    }
  }, []);

  useEffect(() => {
    if (athlete.loadedAthleteIds === athleteID) return;

    const fetchHistoricalData = () => {
      if (
        athlete.athleteHistoricalRawAggSessions.status === "idle" ||
        athlete.loadedAthleteIds !== athleteID
      ) {
        actions.getAthleteHistoricalRawAggSessions(athleteID);
      }
    };

    fetchHistoricalData();
  }, [athleteID]);

  useEffect(() => {
    const fetchSessionList = async () => {
      if (
        sessionList.sessionList.length === 0 &&
        sessionList.status === "idle" &&
        sessionList.status !== "loading"
      ) {
        actions.getSessionList();
      }

      if (session.runData.loaded || session.jumpData.loaded) {
        dispatch(resetAllData());
      }

      if (
        selectedSessionId !==
        (session.runData.sessionID || session.jumpData.sessionID)
      ) {
        checkForJumpData();
      }
    };

    fetchSessionList();
  }, [graphModal, sessionList.sessionList.data, selectedSessionId]);

  useEffect(() => {
    const newOverviewMetricData = [];

    //NOTE sorting by date may be more effective if it is added here
    const rawData =
      filteringByTags.length > 0
        ? athlete.athleteHistoricalRawAggSessions.data.filter((session) =>
            JSON.parse(session.tags).some((tag) =>
              filteringByTags.includes(tag.TID)
            )
          )
        : athlete.athleteHistoricalRawAggSessions.data;

    // raw data variable for the fill data set
    const rawDataFull = athlete.athleteHistoricalRawAggSessions.data;
    // const rawDataFull = athlete.athleteHistoricaRawSessions.data;

    const athleteHistoricalLoad = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [1, 2, 3, 4, 5, 9, 10, 14, 15, 16, 17])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : filteringMethod.presetRange
      ? sortDataByActivity(rawData, [1, 2, 3, 4, 5, 9, 10, 14, 15, 16, 17])
      : sortDataByActivity(rawData, [1, 2, 3, 4, 5, 9, 10, 14, 15, 16, 17]);

    const loadData = filteringMethod.latestSessions
      ? athleteHistoricalLoad
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.loadResults.totalLoad`,
                `rawMetrics.loadResults.relativeLoad`,
                `rawMetrics.loadResults.rightLoad`,
                `rawMetrics.loadResults.leftLoad`,
              ],
              maxMinAvg,
              ["value", "toggledValue", "rightValue", "leftValue"],
              filteringMethod.dateRange || filteringMethod.presetRange,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : athleteHistoricalLoad.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.loadResults.totalLoad`,
              `rawMetrics.loadResults.relativeLoad`,
              `rawMetrics.loadResults.rightLoad`,
              `rawMetrics.loadResults.leftLoad`,
            ],
            maxMinAvg,
            ["value", "toggledValue", "rightValue", "leftValue"],
            filteringMethod.dateRange || filteringMethod.presetRange,
            filteringMethod.latestSessions
          )
        );

    // 1, 2 , 3
    const athleteHistoricalGroundContact = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [1, 2, 3])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : sortDataByActivity(rawData, [1, 2, 3]);

    const groundContactData = filteringMethod.latestSessions
      ? athleteHistoricalGroundContact
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.symmetryResults.contactTime.${maxMinAvg}`,
                `rawMetrics.leftResults.contactTime.${maxMinAvg}`,
                `rawMetrics.rightResults.contactTime.${maxMinAvg}`,
              ],
              maxMinAvg,
              ["value", "leftValue", "rightValue"],
              false,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : athleteHistoricalGroundContact.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.symmetryResults.contactTime.${maxMinAvg}`,
              `rawMetrics.leftResults.contactTime.${maxMinAvg}`,
              `rawMetrics.rightResults.contactTime.${maxMinAvg}`,
            ],
            maxMinAvg,
            ["value", "leftValue", "rightValue"],
            false,
            filteringMethod.latestSessions
          )
        );

    // 3
    const walkDataRaw = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [3])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : sortDataByActivity(rawData, [3]);

    const fullWalkDatalRaw = sortDataByActivityDateless(rawDataFull, [3]);

    setRawDataState((prevValue) => ({
      ...prevValue,
      walkDataRaw: walkDataRaw,
    }));

    setFullRawDataState((prevValue) => ({
      ...prevValue,
      walkDataRaw: fullWalkDatalRaw,
    }));

    const walkGroundContactData = filteringMethod.latestSessions
      ? walkDataRaw
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.meanResults.contactTime.${maxMinAvg}`,
                `rawMetrics.leftResults.contactTime.${maxMinAvg}`,
                `rawMetrics.rightResults.contactTime.${maxMinAvg}`,
              ],
              maxMinAvg,
              ["value", "leftValue", "rightValue"],
              false,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : walkDataRaw.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.meanResults.contactTime.${maxMinAvg}`,
              `rawMetrics.leftResults.contactTime.${maxMinAvg}`,
              `rawMetrics.rightResults.contactTime.${maxMinAvg}`,
            ],
            maxMinAvg,
            ["value", "leftValue", "rightValue"],
            false,
            filteringMethod.latestSessions
          )
        );

    // 2
    const jogDataRaw = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [2])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : sortDataByActivity(rawData, [2]);

    const fullJogDataRaw = sortDataByActivityDateless(rawDataFull, [2]);

    // sorted raw data state
    setRawDataState((prevValue) => ({ ...prevValue, jogDataRaw: jogDataRaw }));

    // sorted full raw data state
    setFullRawDataState((prevValue) => ({
      ...prevValue,
      jogDataRaw: fullJogDataRaw,
    }));

    const jogGroundContactData = filteringMethod.latestSessions
      ? jogDataRaw
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.meanResults.contactTime.${maxMinAvg}`,
                `rawMetrics.rightResults.contactTime.${maxMinAvg}`,
                `rawMetrics.leftResults.contactTime.${maxMinAvg}`,
              ],
              maxMinAvg,
              ["value", "rightValue", "leftValue"],
              false,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : jogDataRaw.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.meanResults.contactTime.${maxMinAvg}`,
              `rawMetrics.rightResults.contactTime.${maxMinAvg}`,
              `rawMetrics.leftResults.contactTime.${maxMinAvg}`,
            ],
            maxMinAvg,
            ["value", "rightValue", "leftValue"],
            false,
            filteringMethod.latestSessions
          )
        );

    // 1
    const sprintDataRaw = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [1])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : sortDataByActivity(rawData, [1]);

    const fullSprintDataRaw = sortDataByActivityDateless(rawDataFull, [1]);

    // sorted raw data state
    setRawDataState((prevValue) => ({
      ...prevValue,
      sprintDataRaw: sprintDataRaw,
    }));

    // sorted full raw data state
    setFullRawDataState((prevValue) => ({
      ...prevValue,
      sprintDataRaw: fullSprintDataRaw,
    }));

    const sprintGroundContactData = filteringMethod.latestSessions
      ? sprintDataRaw
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.meanResults.contactTime.${maxMinAvg}`,
                `rawMetrics.rightResults.contactTime.${maxMinAvg}`,
                `rawMetrics.leftResults.contactTime.${maxMinAvg}`,
              ],
              maxMinAvg,
              ["value", "rightValue", "leftValue"],
              false,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : sprintDataRaw.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.meanResults.contactTime.${maxMinAvg}`,
              `rawMetrics.rightResults.contactTime.${maxMinAvg}`,
              `rawMetrics.leftResults.contactTime.${maxMinAvg}`,
            ],
            maxMinAvg,
            ["value", "rightValue", "leftValue"],
            false,
            filteringMethod.latestSessions
          )
        );

    // 4 //look in here
    const doubleLegCountermovementJumpDataRaw = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [4])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : sortDataByActivity(rawData, [4]);

    const fullDoubleLegCountermovementJumpDataRaw = sortDataByActivityDateless(
      rawDataFull,
      [4]
    );

    // sorted raw data state
    setRawDataState((prevValue) => ({
      ...prevValue,
      doubleLegCountermovementJumpDataRaw: doubleLegCountermovementJumpDataRaw,
    }));

    // sorted full raw data state
    setFullRawDataState((prevValue) => ({
      ...prevValue,
      doubleLegCountermovementJumpDataRaw:
        fullDoubleLegCountermovementJumpDataRaw,
    }));

    const dLCountermovementJumpData = filteringMethod.latestSessions
      ? doubleLegCountermovementJumpDataRaw
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.combinedResults.jumpHeight.${maxMinAvg}`,
                `rawMetrics.leftResults.jumpHeight.${maxMinAvg}`,
                `rawMetrics.rightResults.jumpHeight.${maxMinAvg}`,
              ],
              maxMinAvg,
              ["value", "leftValue", "rightValue"],
              false,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : doubleLegCountermovementJumpDataRaw.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.combinedResults.jumpHeight.${maxMinAvg}`,
              `rawMetrics.leftResults.jumpHeight.${maxMinAvg}`,
              `rawMetrics.rightResults.jumpHeight.${maxMinAvg}`,
            ],
            maxMinAvg,
            ["value", "leftValue", "rightValue"],
            false,
            filteringMethod.latestSessions
          )
        );

    // 10
    const doubleLegRepeatedHopsDataRaw = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [10])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : sortDataByActivity(rawData, [10]);

    const fullDoubleLegRepeatedHopsDataRaw = sortDataByActivityDateless(
      rawDataFull,
      [10]
    );

    // sorted raw data state
    setRawDataState((prevValue) => ({
      ...prevValue,
      doubleLegRepeatedHopsDataRaw: doubleLegRepeatedHopsDataRaw,
    }));

    // sorted full raw data state
    setFullRawDataState((prevValue) => ({
      ...prevValue,
      doubleLegRepeatedHopsDataRaw: fullDoubleLegRepeatedHopsDataRaw,
    }));

    const dLRepeatedHopsData = filteringMethod.latestSessions
      ? doubleLegRepeatedHopsDataRaw
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.combinedResults.RSI.${maxMinAvg}`,
                `rawMetrics.leftResults.RSI.${maxMinAvg}`,
                `rawMetrics.rightResults.RSI.${maxMinAvg}`,
              ],
              maxMinAvg,
              ["value", "leftValue", "rightValue"],
              false,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : doubleLegRepeatedHopsDataRaw.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.combinedResults.RSI.${maxMinAvg}`,
              `rawMetrics.leftResults.RSI.${maxMinAvg}`,
              `rawMetrics.rightResults.RSI.${maxMinAvg}`,
            ],
            maxMinAvg,
            ["value", "leftValue", "rightValue"],
            false,
            filteringMethod.latestSessions
          )
        );

    // 5
    const doubleLegDropJumpDataRaw = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [5])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : sortDataByActivity(rawData, [5]);

    const fullDoubleLegDropJumpDataRaw = sortDataByActivityDateless(
      rawDataFull,
      [5]
    );

    setRawDataState((prevValue) => ({
      ...prevValue,
      doubleLegDropJumpDataRaw: doubleLegDropJumpDataRaw,
    }));

    setFullRawDataState((prevValue) => ({
      ...prevValue,
      doubleLegDropJumpDataRaw: fullDoubleLegDropJumpDataRaw,
    }));

    const dlDropJump = filteringMethod.latestSessions
      ? doubleLegDropJumpDataRaw
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.combinedResults.RSI.${maxMinAvg}`,
                `rawMetrics.leftResults.RSI.${maxMinAvg}`,
                `rawMetrics.rightResults.RSI.${maxMinAvg}`,
              ],
              maxMinAvg,
              ["value", "leftValue", "rightValue"],
              false,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : doubleLegDropJumpDataRaw.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.combinedResults.RSI.${maxMinAvg}`,
              `rawMetrics.leftResults.RSI.${maxMinAvg}`,
              `rawMetrics.rightResults.RSI.${maxMinAvg}`,
            ],
            maxMinAvg,
            ["value", "leftValue", "rightValue"],
            false,
            filteringMethod.latestSessions
          )
        );

    // 9
    const doubleLegSquatJumpDataRaw = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [9])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : sortDataByActivity(rawData, [9]);

    const fullDoubleLegSquatJumpDataRaw = sortDataByActivityDateless(
      rawDataFull,
      [9]
    );

    setRawDataState((prevValue) => ({
      ...prevValue,
      doubleLegSquatJumpDataRaw: doubleLegSquatJumpDataRaw,
    }));

    setFullRawDataState((prevValue) => ({
      ...prevValue,
      doubleLegSquatJumpDataRaw: fullDoubleLegSquatJumpDataRaw,
    }));

    const dlSquatJump = filteringMethod.latestSessions
      ? doubleLegSquatJumpDataRaw
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.combinedResults.jumpHeight.${maxMinAvg}`,
                `rawMetrics.leftResults.jumpHeight.${maxMinAvg}`,
                `rawMetrics.rightResults.jumpHeight.${maxMinAvg}`,
              ],
              maxMinAvg,
              ["value", "leftValue", "rightValue"],
              false,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : doubleLegSquatJumpDataRaw.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.combinedResults.jumpHeight.${maxMinAvg}`,
              `rawMetrics.leftResults.jumpHeight.${maxMinAvg}`,
              `rawMetrics.rightResults.jumpHeight.${maxMinAvg}`,
            ],
            maxMinAvg,
            ["value", "leftValue", "rightValue"],
            false,
            filteringMethod.latestSessions
          )
        );

    //17
    const singleLegRepeatedHopsDataRaw = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [17])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : sortDataByActivity(rawData, [17]);

    const fullSingleLegRepeatedHopsDataRaw = sortDataByActivityDateless(
      rawDataFull,
      [17]
    );

    setRawDataState((prevValue) => ({
      ...prevValue,
      singleLegRepeatedHopsDataRaw: singleLegRepeatedHopsDataRaw,
    }));

    setFullRawDataState((prevValue) => ({
      ...prevValue,
      singleLegRepeatedHopsDataRaw: fullSingleLegRepeatedHopsDataRaw,
    }));

    const slRepeatedHops = filteringMethod.latestSessions
      ? singleLegRepeatedHopsDataRaw
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.symmetryResults.RSI.${maxMinAvg}`,
                `rawMetrics.leftResults.RSI.${maxMinAvg}`,
                `rawMetrics.rightResults.RSI.${maxMinAvg}`,
              ],
              maxMinAvg,
              ["value", "leftValue", "rightValue"],
              false,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : singleLegRepeatedHopsDataRaw.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.symmetryResults.RSI.${maxMinAvg}`,
              `rawMetrics.leftResults.RSI.${maxMinAvg}`,
              `rawMetrics.rightResults.RSI.${maxMinAvg}`,
            ],
            maxMinAvg,
            ["value", "leftValue", "rightValue"],
            false,
            filteringMethod.latestSessions
          )
        );

    // 15
    const singleLegSquatJumpDataRaw = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [15])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : sortDataByActivity(rawData, [15]);

    const fullSingleLegSquatJumpDataRaw = sortDataByActivityDateless(
      rawDataFull,
      [15]
    );

    setRawDataState((prevValue) => ({
      ...prevValue,
      singleLegSquatJumpDataRaw: singleLegSquatJumpDataRaw,
    }));

    setFullRawDataState((prevValue) => ({
      ...prevValue,
      singleLegSquatJumpDataRaw: fullSingleLegSquatJumpDataRaw,
    }));

    const sLSquatJump = filteringMethod.latestSessions
      ? singleLegSquatJumpDataRaw
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.symmetryResults.jumpHeight.${maxMinAvg}`,
                `rawMetrics.leftResults.jumpHeight.${maxMinAvg}`,
                `rawMetrics.rightResults.jumpHeight.${maxMinAvg}`,
              ],
              maxMinAvg,
              ["value", "leftValue", "rightValue"],
              false,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : singleLegSquatJumpDataRaw.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.symmetryResults.jumpHeight.${maxMinAvg}`,
              `rawMetrics.leftResults.jumpHeight.${maxMinAvg}`,
              `rawMetrics.rightResults.jumpHeight.${maxMinAvg}`,
            ],
            maxMinAvg,
            ["value", "leftValue", "rightValue"],
            false,
            filteringMethod.latestSessions
          )
        );

    // 14
    const singleLegCountermovementJumpDataRaw = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [14])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : sortDataByActivity(rawData, [14]);

    const fullSingleLegCountermovementJumpDataRaw = sortDataByActivityDateless(
      rawDataFull,
      [14]
    );

    setRawDataState((prevValue) => ({
      ...prevValue,
      singleLegCountermovementJumpDataRaw: singleLegCountermovementJumpDataRaw,
    }));

    setFullRawDataState((prevValue) => ({
      ...prevValue,
      singleLegCountermovementJumpDataRaw:
        fullSingleLegCountermovementJumpDataRaw,
    }));

    const slCountermovementJumpData = filteringMethod.latestSessions
      ? singleLegCountermovementJumpDataRaw
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.symmetryResults.jumpHeight.${maxMinAvg}`,
                `rawMetrics.leftResults.jumpHeight.${maxMinAvg}`,
                `rawMetrics.rightResults.jumpHeight.${maxMinAvg}`,
              ],
              maxMinAvg,
              ["value", "leftValue", "rightValue"],
              false,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : singleLegCountermovementJumpDataRaw.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.symmetryResults.jumpHeight.${maxMinAvg}`,
              `rawMetrics.leftResults.jumpHeight.${maxMinAvg}`,
              `rawMetrics.rightResults.jumpHeight.${maxMinAvg}`,
            ],
            maxMinAvg,
            ["value", "leftValue", "rightValue"],
            false,
            filteringMethod.latestSessions
          )
        );

    //16
    const singleLegDropJumpDataRaw = filteringMethod.latestSessions
      ? [
          sortDataByActivity(rawData, [16])
            .flatMap((item) => item)
            .slice(0, numberOfLatestSessions),
        ]
      : sortDataByActivity(rawData, [16]);

    const fullSingleLegDropJumpDataRaw = sortDataByActivityDateless(
      rawDataFull,
      [16]
    );

    setRawDataState((prevValue) => ({
      ...prevValue,
      singleLegDropJumpDataRaw: singleLegDropJumpDataRaw,
    }));

    setFullRawDataState((prevValue) => ({
      ...prevValue,
      singleLegDropJumpDataRaw: fullSingleLegDropJumpDataRaw,
    }));

    const sLDropJumpData = filteringMethod.latestSessions
      ? singleLegDropJumpDataRaw
          .map((item) =>
            processArray(
              item,
              [
                `rawMetrics.symmetryResults.RSI.${maxMinAvg}`,
                `rawMetrics.leftResults.RSI.${maxMinAvg}`,
                `rawMetrics.rightResults.RSI.${maxMinAvg}`,
              ],
              maxMinAvg,
              ["value", "leftValue", "rightValue"],
              false,
              filteringMethod.latestSessions
            )
          )
          .flatMap((item) => item)
          .slice(0, numberOfLatestSessions)
      : singleLegDropJumpDataRaw.map((item) =>
          processArray(
            item,
            [
              `rawMetrics.symmetryResults.RSI.${maxMinAvg}`,
              `rawMetrics.leftResults.RSI.${maxMinAvg}`,
              `rawMetrics.rightResults.RSI.${maxMinAvg}`,
            ],
            maxMinAvg,
            ["value", "leftValue", "rightValue"],
            false,
            filteringMethod.latestSessions
          )
        );

    {
      !disabledMetrics.includes("Daily Load") &&
        !disabledMetrics.includes("Session Load") &&
        newOverviewMetricData.push({
          metric:
            filteringMethod.dateRange || filteringMethod.presetRange
              ? "Daily Load"
              : "Session Load",
          toggledMetric: "Relative Load",
          data: loadData?.length && loadData[0] !== undefined ? loadData : [],
          isMetric: false,
          primaryKey: "value",
          primaryToggleKey: "toggledValue",
          bilateral: true,
          secondaryKeys: ["leftValue", "rightValue"],
          toggleable: true,
          togglerKeys: ["Load", "Relative Load"],
          tooltip:
            "Daily load represents to individuals physical effort throughout the day, either by individual limb or accumulative load",
          tooltipToggled:
            "Relative Load is daily load relative to the duration of the sessions collected that day",
          chartValueAxisLabel: "Total Load (a.u.)",
          chartValueAxisLabelToggled: "Total Relative Load (a.u.)",
          chartCategoryAxisLabel: "",
          chartType: "bar",
          xAxisKey: filteringMethod.latestSessions
            ? "sessionNumber"
            : "TSCreated",
          handleElementClick: handleLoadClick,
          customTooltip: LoadCustomTooltip,
          hasSideToggler: false,
          measurementUnit: "a.u",
        });
    }

    {
      !disabledMetrics.includes("Ground Contact") &&
        newOverviewMetricData.push({
          metric: "Ground Contact",
          data:
            groundContactData?.length && groundContactData[0] !== undefined
              ? groundContactData
              : [],
          isMetric: true,
          primaryKey: "value",
          bilateral: true,
          secondaryKeys: ["leftValue", "rightValue"],
          toggleable: false,
          tooltip:
            "Ground contact time asymmetry is defined as the absolute difference between the ground contact time measured for each foot expressed as a percentage of the maximum ground contact time recorded for either foot. The side with the lower ground contact time value will be more asymmetric",
          chartValueAxisLabel: "% Asymmetry",
          chartCategoryAxisLabel: "",
          chartType: "asym-bar",
          xAxisKey: filteringMethod.latestSessions
            ? "sessionNumber"
            : "TSCreated",
          handleElementClick: handleSessionAveragedClick,
          activityListForSelection: [
            {
              value: 1,
              label: "Sprint",
            },
            {
              value: 2,
              label: "Jog",
            },
            {
              value: 3,
              label: "Walk",
            },
          ],
          customTooltip: CustomAsymLineTooltip,
          hasSideToggler: true,
          tooltipLeft: "Left Contact Time",
          tooltipRight: "Right Contact Time",
          tooltipValue: "Ground Contact",
          measurementUnit: "%",
        });
    }

    {
      !disabledMetrics.includes("Sprint Ground Contact Time") &&
        newOverviewMetricData.push({
          metric: "Sprint Ground Contact Time",
          data:
            sprintGroundContactData?.length &&
            sprintGroundContactData[0] !== undefined
              ? sprintGroundContactData
              : [],
          isMetric: true,
          primaryKey: "value",
          bilateral: false,
          secondaryKeys: ["leftValue", "rightValue"],
          toggleable: false,
          tooltip: "Ground contact time",
          chartValueAxisLabel: "Time (s)",
          chartCategoryAxisLabel: "",
          chartType: "line",
          xAxisKey: filteringMethod.latestSessions
            ? "sessionNumber"
            : "TSCreated",
          handleElementClick: handleSessionAveragedClick,
          activityListForSelection: [
            {
              value: 1,
              label: "Sprint",
            },
          ],
          customTooltip: CustomLineTooltip,
          hasSideToggler: true,
          tooltipLeft: "Left Contact Time",
          tooltipRight: "Right Contact Time",
          tooltipValue: "Ground Contact",
          measurementUnit: "s",
        });
    }

    {
      !disabledMetrics.includes("Jog Ground Contact Time") &&
        newOverviewMetricData.push({
          metric: "Jog Ground Contact Time",
          data:
            jogGroundContactData?.length &&
            jogGroundContactData[0] !== undefined
              ? jogGroundContactData
              : [],
          isMetric: true,
          primaryKey: "value",
          bilateral: false,
          secondaryKeys: ["leftValue", "rightValue"],
          toggleable: false,
          tooltip: "Ground contact time",
          chartValueAxisLabel: "Time (s)",
          chartCategoryAxisLabel: "",
          chartType: "line",
          xAxisKey: filteringMethod.latestSessions
            ? "sessionNumber"
            : "TSCreated",
          handleElementClick: handleSessionAveragedClick,
          activityListForSelection: [
            {
              value: 2,
              label: "Jog",
            },
          ],
          customTooltip: CustomLineTooltip,
          hasSideToggler: true,
          tooltipLeft: "Left Contact Time",
          tooltipRight: "Right Contact Time",
          tooltipValue: "Ground Contact",
          measurementUnit: "s",
        });
    }

    {
      !disabledMetrics.includes("Walk Ground Contact Time") &&
        newOverviewMetricData.push({
          metric: "Walk Ground Contact Time",
          data:
            walkGroundContactData?.length &&
            walkGroundContactData[0] !== undefined
              ? walkGroundContactData
              : [],
          isMetric: true,
          primaryKey: "value",
          bilateral: false,
          secondaryKeys: ["leftValue", "rightValue"],
          toggleable: false,
          tooltip: "Ground contact time",
          chartValueAxisLabel: "Time (s)",
          chartCategoryAxisLabel: "",
          chartType: "line",
          xAxisKey: filteringMethod.latestSessions
            ? "sessionNumber"
            : "TSCreated",
          handleElementClick: handleSessionAveragedClick,
          activityListForSelection: [
            {
              value: 3,
              label: "Walk",
            },
          ],
          customTooltip: CustomLineTooltip,
          hasSideToggler: true,
          tooltipLeft: "Left Contact Time",
          tooltipRight: "Right Contact Time",
          tooltipValue: "Ground Contact",
          measurementUnit: "s",
        });
    }

    {
      !disabledMetrics.includes("Double Leg Countermovement Jump") &&
        newOverviewMetricData.push({
          metric: "Double Leg Countermovement Jump",
          data:
            dLCountermovementJumpData?.length &&
            dLCountermovementJumpData[0] !== undefined
              ? dLCountermovementJumpData
              : [],
          isMetric: true,
          primaryKey: "value",
          bilateral: true,
          secondaryKeys: ["leftValue", "rightValue"],
          toggleable: false,
          tooltip: "Double Leg Countermovement Jump (cm)",
          chartValueAxisLabel: "Height (cm)",
          chartCategoryAxisLabel: "",
          chartType: "line",
          customTooltip: CustomLineTooltip,
          xAxisKey: filteringMethod.latestSessions
            ? "sessionNumber"
            : "TSCreated",
          handleElementClick: handleSessionAveragedClick,
          activityListForSelection: [
            {
              value: 4,
              label: "Double Leg Countermovement jump",
            },
          ],
          hasSideToggler: true,
          tooltipValue: "Jump Height",
          tooltipLeft: "Left Foot Height",
          tooltipRight: "Right Foot Height",
          measurementUnit: "cm",
        });
    }

    {
      !disabledMetrics.includes("Double Leg Repeated Hops") &&
        newOverviewMetricData.push({
          metric: "Double Leg Repeated Hops",
          data:
            dLRepeatedHopsData?.length && dLRepeatedHopsData[0] !== undefined
              ? dLRepeatedHopsData
              : [],
          isMetric: true,
          primaryKey: "value",
          bilateral: true,
          secondaryKeys: ["leftValue", "rightValue"],
          toggleable: false,
          tooltip: "Double Leg Repeated Hops (RSI)",
          chartValueAxisLabel: "Reactive Strength Index (RSI)",
          chartCategoryAxisLabel: "",
          chartType: "line",
          customTooltip: CustomLineTooltip,
          xAxisKey: filteringMethod.latestSessions
            ? "sessionNumber"
            : "TSCreated",
          handleElementClick: handleSessionAveragedClick,
          activityListForSelection: [
            {
              value: 10,
              label: "Double Leg Repeated Hops",
            },
          ],
          hasSideToggler: true,
          tooltipValue: "RSI",
          tooltipLeft: "Left Foot RSI",
          tooltipRight: "Right Foot RSI",
          measurementUnit: "RSI",
        });
    }

    {
      !disabledMetrics.includes("Double Leg Drop Jump") &&
        newOverviewMetricData.push({
          metric: "Double Leg Drop Jump",
          data:
            dlDropJump?.length && dlDropJump[0] !== undefined ? dlDropJump : [],
          isMetric: true,
          primaryKey: "value",
          bilateral: true,
          secondaryKeys: ["leftValue", "rightValue"],
          toggleable: false,
          tooltip: "Double Leg Drop Jump (RSI)",
          chartValueAxisLabel: "Reactive Strength Index (RSI)",
          chartCategoryAxisLabel: "",
          chartType: "line",
          xAxisKey: filteringMethod.latestSessions
            ? "sessionNumber"
            : "TSCreated",
          handleElementClick: handleSessionAveragedClick,
          activityListForSelection: [
            {
              value: 5,
              label: "Double Leg Drop Jump",
            },
          ],
          customTooltip: CustomLineTooltip,
          hasSideToggler: true,
          tooltipValue: "RSI",
          tooltipLeft: "Left Foot RSI",
          tooltipRight: "Right Foot RSI",
          measurementUnit: "RSI",
        });
    }

    {
      !disabledMetrics.includes("Double Leg Squat Jump") &&
        newOverviewMetricData.push({
          metric: "Double Leg Squat Jump",
          data:
            dlSquatJump?.length && dlSquatJump[0] !== undefined
              ? dlSquatJump
              : [],
          isMetric: true,
          primaryKey: "value",
          bilateral: true,
          secondaryKeys: ["leftValue", "rightValue"],
          toggleable: false,
          tooltip: "Double Leg Squat Jump (Height)",
          chartValueAxisLabel: "Height (cm)",
          chartCategoryAxisLabel: "",
          chartType: "line",
          xAxisKey: filteringMethod.latestSessions
            ? "sessionNumber"
            : "TSCreated",
          handleElementClick: handleSessionAveragedClick,
          activityListForSelection: [
            {
              value: 9,
              label: "Double Leg Squat Jump",
            },
          ],
          customTooltip: CustomLineTooltip,
          hasSideToggler: true,
          tooltipValue: "Jump Height",
          tooltipLeft: "Left Foot Height",
          tooltipRight: "Right Foot Height",
          measurementUnit: "cm",
        });
    }

    {
      !disabledMetrics.includes("Single Leg Repeated Hops") &&
        newOverviewMetricData.push({
          metric: "Single Leg Repeated Hops",
          data:
            slRepeatedHops?.length && slRepeatedHops[0] !== undefined
              ? slRepeatedHops
              : [],
          isMetric: true,
          primaryKey: "value",
          bilateral: true,
          secondaryKeys: ["leftValue", "rightValue"],
          toggleable: false,
          tooltip: "Single Leg Repeated Hops (%)",
          chartValueAxisLabel: "% Asymmetry",
          chartCategoryAxisLabel: "",
          chartType: "asym-bar",
          xAxisKey: filteringMethod.latestSessions
            ? "sessionNumber"
            : "TSCreated",
          handleElementClick: handleSessionAveragedClick,
          activityListForSelection: [
            {
              value: 17,
              label: "Single Leg Repeated Hops",
            },
          ],
          customTooltip: CustomAsymLineTooltip,
          hasSideToggler: true,
          tooltipValue: "RSI",
          tooltipLeft: "Left Foot RSI",
          tooltipRight: "Right Foot RSI",
          measurementUnit: "%",
        });
    }

    // disbaled single leg squat jump temp
    // {
    //   !disabledMetrics.includes("Single Leg Squat Jump") &&
    //     newOverviewMetricData.push({
    //       metric: "Single Leg Squat Jump",
    //       data: rawDataState?.singleLegSquatJumpDataRaw?.length
    //         ? sLSquatJump
    //         : [],
    //       isMetric: true,
    //       primaryKey: "value",
    //       bilateral: true,
    //       secondaryKeys: ["leftValue", "rightValue"],
    //       toggleable: false,
    //       tooltip:
    //         "Single Leg Squat Jump (%) negative values indicate asymmetry left, positive values indicate asymmetry right",
    //       chartValueAxisLabel: "% Asymmetry",
    //       chartCategoryAxisLabel: "",
    //       chartType: "asym-bar",
    //       xAxisKey: filteringMethod.latestSessions
    //         ? "sessionNumber"
    //         : "TSCreated",
    //       handleElementClick: handleSessionAveragedClick,
    //       hasSideToggler: true,
    //       customTooltip: CustomAsymLineTooltip,
    //       tooltipLeft: "Left Foot Height",
    //       tooltipRight: "Right Foot Height",
    //       tooltipValue: "Jump Height",
    //       measurementUnit: "%",
    //     });
    // }

    {
      !disabledMetrics.includes("Single Leg Countermovement Jump") &&
        newOverviewMetricData.push({
          metric: "Single Leg Countermovement Jump",
          data:
            slCountermovementJumpData?.length &&
            slCountermovementJumpData[0] !== undefined
              ? slCountermovementJumpData
              : [],
          isMetric: true,
          primaryKey: "value",
          bilateral: true,
          secondaryKeys: ["leftValue", "rightValue"],
          toggleable: false,
          tooltip:
            "Single Leg Countermovement Jump (%) negative values indicate asymmetry left, positive values indicate asymmetry right",
          chartValueAxisLabel: "% Asymmetry",
          chartCategoryAxisLabel: "",
          chartType: "asym-bar",
          xAxisKey: filteringMethod.latestSessions
            ? "sessionNumber"
            : "TSCreated",
          handleElementClick: handleSessionAveragedClick,
          activityListForSelection: [
            {
              value: 14,
              label: "Single Leg Countermovement Jump",
            },
          ],
          hasSideToggler: true,
          customTooltip: CustomAsymLineTooltip,
          tooltipLeft: "Left Foot Height",
          tooltipRight: "Right Foot Height",
          tooltipValue: "Jump Height Asymmetry",
          measurementUnit: "%",
        });
    }
    // temp disable single leg drop jump
    // {
    //   !disabledMetrics.includes("Single Leg Drop Jump") &&
    //     newOverviewMetricData.push({
    //       metric: "Single Leg Drop Jump",
    //       data: rawDataState?.singleLegDropJumpDataRaw?.length
    //         ? sLDropJumpData
    //         : [],
    //       isMetric: true,
    //       primaryKey: "value",
    //       bilateral: true,
    //       secondaryKeys: ["leftValue", "rightValue"],
    //       toggleable: false,
    //       tooltip: "Single Leg Drop Jump (%)",
    //       chartValueAxisLabel: "% Asymmetry",
    //       chartCategoryAxisLabel: "",
    //       chartType: "asym-bar",
    //       xAxisKey: filteringMethod.latestSessions
    //         ? "sessionNumber"
    //         : "TSCreated",
    //       handleElementClick: handleSessionAveragedClick,
    //       hasSideToggler: true,
    //       customTooltip: CustomAsymLineTooltip,
    //       tooltipLeft: "Left Foot RSU",
    //       tooltipRight: "Right Foot RSU",
    //       tooltipValue: "Jump Height Asymmetry",
    //       measurementUnit: "%",
    //     });
    // }

    setOverviewMetricData(newOverviewMetricData);

    //sym res jump height
  }, [
    athlete,
    numberOfLatestSessions,
    filteringMethod,
    disabledMetrics,
    maxMinAvg,
    filteringByTags,
  ]);

  useEffect(() => {
    const arrayOfTags = athlete.athleteHistoricalRawAggSessions.data.length
        ? athlete.athleteHistoricalRawAggSessions.data.flatMap((item) =>
            JSON.parse(item.tags)
          )
        : [];

    const uniqueTIDs = new Set();

    const uniqueArrayOfTagsVar = arrayOfTags.length
        ? arrayOfTags.filter((item) => {
            if (
              item &&
              item.TID !== null &&
              item.TID !== undefined &&
              !uniqueTIDs.has(item.TID)
            ) {
              uniqueTIDs.add(item.TID);
              return true;
            }
            return false;
          })
        : [];

    setUniqueArrayOfTags(uniqueArrayOfTagsVar);
  }, [athlete]);

  useEffect(() => {
    // Update the last updated time whenever overviewMetricData changes
    setLastUpdated(Date.now());

    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set a new timeout to log "rerender" after 3 seconds
    timeoutRef.current = setTimeout(() => {
      const currentTime = Date.now();
      // Check if 3 seconds have passed since the last update
      if (currentTime - lastUpdated >= 1000) {
        setIsLoading(false);
      }
    }, 1000);

    // Clean up the timeout on component unmount or before running the effect again
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [overviewMetricData]);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 1);
  }, [isLoading]);

  const getPastDate = (number, period) => {
    const currentDate = new Date();

    switch (period.toLowerCase()) {
      case "day":
      case "days":
        currentDate.setDate(currentDate.getDate() - number);
        break;
      case "week":
      case "weeks":
        currentDate.setDate(currentDate.getDate() - number * 7);
        break;
      case "month":
      case "months":
        currentDate.setMonth(currentDate.getMonth() - number);
        break;
      case "year":
      case "years":
        currentDate.setFullYear(currentDate.getFullYear() - number);
        break;
      default:
        throw new Error(
          "Invalid period. Use 'Day', 'Week', 'Month', or 'Year'."
        );
    }

    return currentDate;
  };
  const sortDataByActivityDateless = (data, activityId) => {
    let returnedData = [];
    if (data.length) {
      if (activityId.length) {
        returnedData = data
          .filter((item) => activityId.includes(item.activity))
          .map((item) => ({
            ...item,
            rawMetrics: JSON.parse(item.rawMetrics || item.aggMetrics),
          }));
      } else {
        returnedData = data?.map((item) => ({
          ...item,
          rawMetrics: JSON.parse(item.rawMetrics || item.aggMetrics),
        }));
      }
    }
    return groupByDate(returnedData);
  };

  const sortDataByActivity = (data, activityId) => {
    let returnedData = [];
    if (data.length) {
      if (activityId.length) {
        returnedData = data
          .filter((item) => activityId.includes(item.activity))
          .map((item) => ({
            ...item,
            rawMetrics: JSON.parse(item.rawMetrics || item.aggMetrics),
          }));
      } else {
        returnedData = data?.map((item) => ({
          ...item,
          rawMetrics: JSON.parse(item.rawMetrics || item.aggMetrics),
        }));
      }
    }

    if (filteringMethod.dateRange) {
      const startDate = filterDate.startDate
        ? new Date(filterDate.startDate)
        : null;
      const endDate = filterDate.endDate ? new Date(filterDate.endDate) : null;

      if (overviewMetricData.length) {
        const newMetricDataSorted = returnedData.filter((item) => {
          const metricDate = item?.TSCreated ? new Date(item?.TSCreated) : null;
          if (
            (startDate &&
              metricDate &&
              metricDate.getTime() <= startDate.getTime()) ||
            (endDate && metricDate && metricDate.getTime() >= endDate.getTime())
          ) {
            return false;
          }
          return true;
        });

        return groupByDate(newMetricDataSorted);
      }
    }

    if (filteringMethod.presetRange) {
      return groupByDate(
        filterByDateRange(
          returnedData,
          getPastDate(rangeFiltering.number, rangeFiltering.selected)
        )
      );
    }

    return groupByDate(returnedData);
  };
  //filter by date range
  const filterByDateRange = (dataArray, pastDateStr) => {
    const presentDate = new Date();
    const pastDate = new Date(pastDateStr);

    if (isNaN(pastDate.getTime())) {
      //console.log("Invalid past date format");
    }

    return dataArray.filter((item) => {
      const itemDate = new Date(item.TSCreated);
      return itemDate <= presentDate && itemDate >= pastDate;
    });
  };

  const processArray = (
    arrays,
    keys,
    operator,
    keyLabels,
    dateSorting = false,
    latestSessions = false
  ) => {
    if (!Array.isArray(arrays) || arrays.length === 0) {
      //console.log("Input must be a non-empty array of arrays.");
      return;
    }

    if (
      !Array.isArray(keys) ||
      !Array.isArray(keyLabels) ||
      keys.length !== keyLabels.length
    ) {
      //console.log("Keys and keyLabels must be arrays of the same length.");
      return;
    }

    const flattenedData = arrays.flat();
    if (flattenedData.length === 0) {
      //console.log("Input arrays must contain objects.");
      return;
    }

    // only if looking at latest sessions
    if (latestSessions) {
      //console.log("Using latest session inside process array");

      // Function to add keys to the existing object
      const processedKeys = (object) => {
        keyLabels.forEach((item, index) => {
          object[item] = accessNestedProperty(object, keys[index]); // Adds the new key-value pair to the object
        });
      };

      function ordinal_suffix_of(i) {
        let j = i % 10,
          k = i % 100;
        if (j === 1 && k !== 11) {
          return i + "st";
        }
        if (j === 2 && k !== 12) {
          return i + "nd";
        }
        if (j === 3 && k !== 13) {
          return i + "rd";
        }
        return i + "th";
      }

      // Process each item in flattenedData
      flattenedData.forEach((item, index) => {
        item.sessionNumber =
          index === 0
            ? "Latest Session"
            : `${ordinal_suffix_of(index + 1)} Session`;
        processedKeys(item); // Mutate the item directly by adding keys
      });
      return flattenedData;
    }

    function getValue(obj, nestedKey) {
      const keyParts = nestedKey.split(".");
      let currentObj = obj;
      for (const k of keyParts) {
        if (!currentObj || !currentObj.hasOwnProperty(k)) {
          //console.log(`Key "${nestedKey}" does not exist in the objects.`);
          return undefined; // Exit if key doesn't exist
        }
        currentObj = currentObj[k];
      }
      return currentObj;
    }

    const results = {};
    const totalSums = {};
    const counts = {};
    const minValues = {};
    const maxValues = {};
    const minObjects = {};
    const maxObjects = {};

    flattenedData.forEach((obj) => {
      keys.forEach((key, index) => {
        const keyLabel = keyLabels[index];
        const value = getValue(obj, key);
        if (typeof value !== "number") return;

        // Sum calculation (for avg and dateSorting)
        if (operator === "avg" || dateSorting) {
          if (!totalSums[keyLabel]) totalSums[keyLabel] = 0;
          if (!counts[keyLabel]) counts[keyLabel] = 0;
          totalSums[keyLabel] += value;
          counts[keyLabel]++;
        }

        // Min calculation
        if (operator === "min") {
          if (!minValues[keyLabel] || value < minValues[keyLabel]) {
            minValues[keyLabel] = value;
            minObjects[keyLabel] = obj;
          }
        }

        // Max calculation
        if (operator === "max") {
          if (!maxValues[keyLabel] || value > maxValues[keyLabel]) {
            maxValues[keyLabel] = value;
            maxObjects[keyLabel] = obj;
          }
        }
      });
    });

    // Final aggregation
    keys.forEach((key, index) => {
      const keyLabel = keyLabels[index];

      if (dateSorting) {
        results[keyLabel] = totalSums[keyLabel] || 0;
      } else {
        switch (operator) {
          case "avg":
            results[keyLabel] =
              (totalSums[keyLabel] || 0) / (counts[keyLabel] || 1);
            break;
          case "min":
            const minObject = minObjects[keyLabel];
            results[keyLabel] = minValues[keyLabel];
            if (minObject) {
              Object.keys(minObject).forEach((k) => {
                if (k !== "rawMetrics" && !results.hasOwnProperty(k)) {
                  results[k] = minObject[k];
                }
              });
            }
            break;
          case "max":
            const maxObject = maxObjects[keyLabel];
            results[keyLabel] = maxValues[keyLabel];
            if (maxObject) {
              Object.keys(maxObject).forEach((k) => {
                if (k !== "rawMetrics" && !results.hasOwnProperty(k)) {
                  results[k] = maxObject[k];
                }
              });
            }
            break;
          default:
            throw new Error(
              "Invalid operator. Supported operators: avg, min, max."
            );
        }
      }
    });

    results.TSCreated = flattenedData[0].TSCreated;
    return results;
  };

  const groupByDate = (dataArray) => {
    // console.log("data array :",dataArray )
    function extractDate(tsCreated) {
      return tsCreated.split("T")[0];
    }

    const dateMap = dataArray.reduce((acc, item) => {
      const date = extractDate(item.TSCreated);
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(item);
      return acc;
    }, {});

    // Sort the dates in descending order
    const sortedDates = Object.keys(dateMap).sort(
      (a, b) => new Date(b) - new Date(a)
    );

    // Create the sorted array of arrays
    const sortedArray = sortedDates.map((date) => dateMap[date]);

    return sortedArray;
  };

  const closeModal = () => {
    dispatch(setGraphModal(!graphModal));
    dispatch(setSelectedSessionId(null));
    setTimeout(() => {
      window.scrollTo({ top: Math.round(scrollPosition), behavior: "smooth" });
    }, 100);
  };

  const handleIsOutsideRange = useCallback(() => false, []);
  const handleDatesChange = useCallback(({ startDate, endDate }) => {
    setFilterDate({ startDate, endDate });
    setFilteringMethod((prev) => ({
      latestSessions: false,
      presetRange: false,
      dateRange: true,
    }));
  }, []);

  const allDates =
    athlete.athleteHistoricalRawAggSessions.data.length > 0
      ? athlete.athleteHistoricalRawAggSessions.data.map((item) =>
          moment(item.TSCreated).format("DD/MM/YYYY")
        )
      : [];

  // selectedTags, setSelectedTags
  const handleTagClick = (tagID) => {
    if (!selectedTags.includes(tagID)) {
      setSelectedTags((prev) => [...prev, tagID]);
    } else {
      setSelectedTags((prev) => [...prev.filter((item) => item !== tagID)]);
    }
  };

  const handleTagClear = () => {
    setSelectedTags([]);
  };

  const handleTagSelectedForFilter = (tag) => {
    if (!filteringByTags.includes(tag.TID)) {
      setFilteringByTags((prevTags) => [...prevTags, tag.TID]);
    }
    if (filteringByTags.includes(tag.TID)) {
      setFilteringByTags((prevTags) => [
        ...prevTags.filter((item) => item !== tag.TID),
      ]);
    }
  };

  //user overview layout displayed metrics and appearance
  async function updateOverviewMetricsAndAppearanceLayout() {
    const localStorageData = JSON.parse(localStorage.getItem("userLayout"));

    const postBody = {
      layout: JSON.stringify({
        pdf: { ...localStorageData.pdf },
        comparison: { ...localStorageData.comparison },
        sessionLayout: { ...localStorageData.sessionLayout },
        theme: { ...localStorageData.theme},
        athleteOverview: {
          ...localStorageData.athleteOverview,
          disabledMetrics: disabledMetrics,
          appearanceSelected: appearanceSelected,
        }
      }),
    };
     localStorage.setItem("userLayout", postBody.layout);
    await updateUserLayoutAPI(postBody);
  }

  //toggle handler
  const handleCardToggle = () => {
    setToggleCards((prev) => !prev);
  };

  //dates to string
  const firstDate = filterDate.startDate
    ? new Date(filterDate.startDate).toDateString()
    : null;
  const secondDate = filterDate.endDate
    ? new Date(filterDate.endDate).toDateString()
    : null;

  const renderDay = (day) => {
    return moment(day._d).format("DD/MM/YYYY") ===
      moment().format("DD/MM/YYYY") ? (
      <div
        style={{
          color: NEW_RIGHT_COLOR,
          fontWeight: "bold",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <span>{day.format("D")}</span>
        {allDates.includes(moment(day._d).format("DD/MM/YYYY")) ? (
          <div
            style={{
              height: "8px",
              width: "8px",
              backgroundColor: NEW_RIGHT_COLOR,
              borderRadius: "4px",
            }}
          ></div>
        ) : (
          <div style={{ height: "8px", width: "8px" }}></div>
        )}
      </div>
    ) : (
      <div
        style={{
          color: mode === "light" ? "black" : "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <span>{day.format("D")}</span>
        {allDates.includes(moment(day._d).format("DD/MM/YYYY")) ? (
          <div
            style={{
              height: "8px",
              width: "8px",
              backgroundColor: NEW_RIGHT_COLOR,
              borderRadius: "4px",
            }}
          ></div>
        ) : (
          <div style={{ height: "8px", width: "8px" }}></div>
        )}
      </div>
    );
  };

  async function updateOverviewLayout() {
    const localStorageData = JSON.parse(localStorage.getItem("userLayout"));

    const postBody = {
      layout: JSON.stringify({
        pdf: { ...localStorageData.pdf },
        comparison: { ...localStorageData.comparison },
        sessionLayout: { ...localStorageData.sessionLayout },
        theme: { ...localStorageData.theme},
        athleteOverview: {
          ...localStorageData.athleteOverview,
          filteringMethod: filteringMethod,
          rangeFiltering: rangeFiltering,
          maxMinAvg: maxMinAvg,
          numberOfLatestSessions: numberOfLatestSessions,
        }
      }),
    };
    localStorage.setItem("userLayout", postBody.layout);
    await updateUserLayoutAPI(postBody);
  }

  const uniqueID = nanoid();

  return (
    <div className="athlete_overview_container">
      {!isLoading ? (
        <div className="athlete_overview_summary_controls">
          <div
            className="summary_controls_filter"
            style={{ minWidth: `${100 / columns - 0.8}%` }}
          >
            {/* Modal to go in here*/}
            <div
              className={`athlete_overview_table_display_modal ${
                filterToggleModal
                  ? "athlete_overview_table_display_modal_open"
                  : ""
              }`}
              ref={filterModalRef}
            >
              <div className="filter_modal_heading">
                <h5>Sort By</h5>
              </div>
              <div className="filter_modal_options">
                <div className="counter_options">
                  <div
                    className={`counter date_counter option ${
                      filteringMethod.presetRange ? "current_counter" : ""
                    }`}
                    onClick={() =>
                      setFilteringMethod((prev) => ({
                        unset: false,
                        latestSessions: false,
                        presetRange: true,
                        dateRange: false,
                      }))
                    }
                  >
                    <div className="filter_modal_heading">
                      <h5>Date</h5>
                      <p>View all sessions from</p>
                    </div>
                    <div className="counter_controls">
                      <div className="multiple_controls">
                        <CounterOrSelector
                          selectorType={"number_scale"}
                          value={rangeFiltering.number}
                          setValue={setRangeFiletering}
                          isSelected={filteringMethod.presetRange}
                          selectorWidth={40}
                        />
                        <CounterOrSelector
                          selectorType={"selection_scale"}
                          value={rangeFiltering.selected}
                          setValue={setRangeFiletering}
                          isSelected={filteringMethod.presetRange}
                          selectorWidth={80}
                          selections={rangeFiltering.selections}
                          values={rangeFiltering}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`counter session_counter option ${
                      filteringMethod.latestSessions ? "current_counter" : ""
                    }`}
                    onClick={() =>
                      setFilteringMethod((prev) => ({
                        unset: false,
                        latestSessions: true,
                        presetRange: false,
                        dateRange: false,
                      }))
                    }
                  >
                    <div className="filter_modal_heading">
                      <h5>Sessions</h5>
                      <p>
                        View Last <span>{numberOfLatestSessions}</span> sessions
                      </p>
                    </div>
                    <div className="counter_controls">
                      <CounterOrSelector
                        selectorType={"number"}
                        value={numberOfLatestSessions}
                        setValue={setNumberOfLatestSessions}
                        isSelected={filteringMethod.latestSessions}
                        selectorWidth={70}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={`counter date_picker_option option ${
                    filteringMethod.dateRange ? "current_counter" : ""
                  }`}
                  onClick={() =>
                    setFilteringMethod((prev) => ({
                      unset: false,
                      latestSessions: false,
                      presetRange: false,
                      dateRange: true,
                    }))
                  }
                >
                  <div className="session_counter">
                    <div className="filter_modal_heading">
                      <h5>Specific Range</h5>
                    </div>
                    <div
                      className={`${
                        filteringMethod.dateRange
                          ? "date_range_container_active"
                          : "date_range_container"
                      } `}
                    >
                      <DateRangePicker
                        startDate={filterDate?.startDate}
                        minimumNights={0}
                        startDateId="start_date_overview"
                        endDate={filterDate?.endDate}
                        endDateId="end_date_overview"
                        onDatesChange={handleDatesChange}
                        numberOfMonths={1}
                        keepOpenOnDateSelect={true}
                        focusedInput={
                          focusedInput2 ? focusedInput2 : "startDate"
                        }
                        onFocusChange={(focusedInput2) =>
                          setFocusedInput2(focusedInput2)
                        }
                        displayFormat={"DD/MM/YYYY"}
                        isOutsideRange={handleIsOutsideRange}
                        renderDayContents={renderDay}
                      />
                    </div>
                  </div>
                </div>
                <div className="tag_options">
                  <div className="tag_options_heading">
                    <h5>Tags</h5>
                  </div>
                  <div className="tag_options_search">
                    <input
                      type="text"
                      name="tag-search"
                      autoComplete="off"
                      value={tagsSearch}
                      id={uniqueID}
                      placeholder="Search..."
                      onChange={(e) => setTagsSearch(e.target.value)}
                    />
                  </div>
                  <div className="tag_options_container">
                    {uniqueArrayOfTags
                      .filter((item) =>
                        item.tag
                          .split(" ")
                          .join("")
                          .toLowerCase()
                          .includes(tagsSearch.toLocaleLowerCase())
                      )
                      .map((item) => (
                        <div
                          className={`tag ${
                            filteringByTags.includes(item.TID)
                              ? "tag_selected"
                              : ""
                          }`}
                          key={item.TID}
                          onClick={() => handleTagSelectedForFilter(item)}
                        >
                          {filteringByTags.includes(item.TID) ? (
                            <div className="close_icon">
                              <EscapeIcon size="15" />
                            </div>
                          ) : (
                            ""
                          )}

                          <p>{item.tag}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="filter_modal_buttons">
                <div
                  onClick={() => {
                    updateOverviewLayout(),
                      setFilterToggleModal((prev) => !prev);
                  }}
                >
                  <MainButton buttonText={"Save Preference"} />
                </div>
              </div>
            </div>
            <div
              className="summary_control_modal"
              onClick={() => setFilterToggleModal((prev) => !prev)}
            >
              <div className="summary_control_summary">
                {filteringMethod.latestSessions ? (
                  <div className="summary_control_summary_headings">
                    <p>Displaying Last {numberOfLatestSessions} Sessions</p>
                  </div>
                ) : null}
                {filteringMethod.presetRange ? (
                  <div className="summary_control_summary_headings">
                    <p>
                      Displaying Last{" "}
                      {`${rangeFiltering.number} ${rangeFiltering.selected}${
                        rangeFiltering.number > 1 ? "s" : ""
                      }`}
                    </p>
                  </div>
                ) : null}
                {filteringMethod.dateRange ? (
                  firstDate || secondDate ? (
                    <div className="summary_control_summary_headings">
                      <p>
                        {firstDate} - {secondDate}
                      </p>
                    </div>
                  ) : (
                    <div className="summary_control_summary_headings">
                      <p>Please select date range</p>
                    </div>
                  )
                ) : null}
              </div>
              <div className="summary_control_arrow">
                <Polygon />
              </div>
            </div>
          </div>
          <div
            className="summary_controls"
            style={{ minWidth: `${100 / columns - 0.8}%` }}
          >
            {maxMinAvg === "avg" && !filteringMethod.latestSessions ? (
              <MainTooltip
                tooltipText={
                  "When 'Average' is selected, all the graphs below—except for Load—cannot open a session when points or bars are clicked. This is because the displayed data comprises multiple sessions."
                }
              />
            ) : null}
            <div onClick={() => downloadButtonClicked()}>
              {/* <DownloadIcon
                color={isDownloading ? "rgba(26, 188, 156,0.7)" : "white"}
                size={24}
              /> */}
              <MainButton
                buttonText={""}
                ButtonIcon={DownloadIcon}
                buttonLoading={isDownloading}
                buttonBoxShadow={true}
              />
            </div>
            <div className="athlete_overview_table_dropdown" ref={dropdownRef}>
              <div
                className="dropdown_button"
                onClick={() => setDropdownOpen((prev) => !prev)}
              >
                <Polygon direction={!dropdownOpen ? "down" : "up"} />
                <p>
                  {maxMinAvg === "max"
                    ? "Maximum"
                    : maxMinAvg === "avg"
                    ? "Average"
                    : "Minimum"}
                </p>
              </div>
              <div
                className={`dropdown_body ${
                  !dropdownOpen ? "dropdown_body_closed" : ""
                }`}
              >
                <div
                  className="dropdown_body_option"
                  onClick={() => {
                    setDropdownOpen((prev) => !prev);
                    setMaxMinAvg("max");
                  }}
                >
                  <p
                    className={`${maxMinAvg === "max" ? "active_option" : ""}`}
                  >
                    Maximum
                  </p>
                </div>
                <div className="dropdown_divider"></div>
                <div
                  className="dropdown_body_option"
                  onClick={() => {
                    setDropdownOpen((prev) => !prev);
                    setMaxMinAvg("avg");
                  }}
                >
                  <p
                    className={`${maxMinAvg === "avg" ? "active_option" : ""}`}
                  >
                    Average
                  </p>
                </div>
                <div className="dropdown_divider"></div>
                <div
                  className="dropdown_body_option"
                  onClick={() => {
                    setDropdownOpen((prev) => !prev);
                    setMaxMinAvg("min");
                  }}
                >
                  <p
                    className={`${maxMinAvg === "min" ? "active_option" : ""}`}
                  >
                    Minimum
                  </p>
                </div>
              </div>
            </div>
            <div>
              <MainModal
                button={
                  <MainButton
                    buttonText={"Highlight"}
                    ButtonIcon={BookmarkIcon}
                    buttonBoxShadow={true}
                  />
                  // <div className="overview_table_button">
                  //   <BookmarkIcon size="24" color="white" fillOpacity="1" />
                  //   <p>Hightlight</p>
                  // </div>
                }
                modalBody={
                  <TagsSelectionModalBody
                    uniqueArrayOfTags={uniqueArrayOfTags}
                    selectedTags={selectedTags}
                    handleTagClick={handleTagClick}
                  />
                }
                modalButtons={
                  <div className="table_settings_modal_buttons">
                    <div onClick={() => handleTagClear()}>
                      <MainButton buttonText={"Clear"} />
                    </div>
                  </div>
                }
              />
            </div>
            <div>
              <MainModal
                button={
                  <MainButton
                    buttonText={"Settings"}
                    ButtonIcon={Settings}
                    buttonBoxShadow={true}
                  />
                  // <div className="overview_table_button">
                  //   <Settings size="24" color="white" fillOpacity="1" />
                  //   <p>Settings</p>
                  // </div>
                }
                modalBody={
                  <TableSettingsModalBody
                    allMetrics={overviewMetricData}
                    selectedMetricsForToggleState={
                      selectedMetricsForToggleState
                    }
                    setSelectedMetricsForToggleState={
                      setSelectedMetricsForToggleState
                    }
                    disabledMetrics={disabledMetrics}
                    setDisabledMetrics={setDisabledMetrics}
                    appearanceSelected={appearanceSelected}
                    setAppearanceSelected={setAppearanceSelected}
                    updateOverviewMetricsAndAppearanceLayout={
                      updateOverviewMetricsAndAppearanceLayout
                    }
                  />
                }
                modalButtons={
                  <div className="table_settings_modal_buttons">
                    <div
                      onClick={() => updateOverviewMetricsAndAppearanceLayout()}
                    >
                      <MainButton buttonText={"Save Layout"} buttonBoxShadow={true}/>
                    </div>
                  </div>
                }
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="athlete_overview_summary_controls">
          <div
            className="summary_controls_filter"
            style={{ minWidth: `${100 / columns - 0.8}%` }}
          >
            {/* Modal to go in here*/}
            <div className="summary_control_modal shimmer"></div>
          </div>
          <div
            className="summary_controls"
            style={{ minWidth: `${100 / columns - 0.8}%` }}
          >
            <div className={`athlete_overview_card_button shimmer`}></div>
            <div className="athlete_overview_table_dropdown shimmer">
              <div className="dropdown_button"></div>
              <div
                className={`dropdown_body ${
                  !dropdownOpen ? "dropdown_body_closed" : ""
                }`}
              ></div>
            </div>

            <div className="athlete_overview_table_dropdown shimmer">
              <div className="dropdown_button"></div>
              <div
                className={`dropdown_body ${
                  !dropdownOpen ? "dropdown_body_closed" : ""
                }`}
              ></div>
            </div>

            <div className="athlete_overview_table_dropdown shimmer">
              <div className="dropdown_button"></div>
              <div
                className={`dropdown_body ${
                  !dropdownOpen ? "dropdown_body_closed" : ""
                }`}
              ></div>
            </div>
          </div>
        </div>
      )}
      <div className="athlete_overview_summary" dir="ltr">
        {placeholderObject.map((item) => (
          <AthleteOverviewSummaryCard
            athleteOverviewCardTitle={item.summaryTitle}
            summaryType={item.summaryType}
            summaryFor={item.summaryFor}
            isLoading={isLoading}
            columns={columns}
            rawDataState={rawDataState}
            fullRawDataState={fullRawDataState}
            maxMinAvg={maxMinAvg}
            processArray={processArray}
            groupByDate={groupByDate}
            overviewMetricData={overviewMetricData}
            filteringMethod={filteringMethod}
            toggleCards={toggleCards}
            numberOfLatestSessions={numberOfLatestSessions}
          />
        ))}
      </div>
      {!isLoading ? (
        <div className="athlete_overview_summary_toggler">
          <div
            className={`athlete_overview_card_button ${
              toggleCards
                ? "athlete_overview_card_button_rotate_down"
                : "athlete_overview_card_button_rotate_up"
            }`}
            onClick={() => handleCardToggle()}
          >
            <Polygon size={20} />
          </div>
        </div>
      ) : (
        <div className="athlete_overview_summary_toggler shimmer">
          <div
            className={`athlete_overview_card_button ${
              toggleCards
                ? "athlete_overview_card_button_rotate_down"
                : "athlete_overview_card_button_rotate_up"
            }`}
            // onClick={() => handleCardToggle()}
          >
            {/* <Polygon size={20} /> */}
          </div>
        </div>
      )}
      <div className="athlete_overview_table">
        <AthleteOverviewMainTable
          tableData={overviewMetricData}
          tableDataFullDates={allDates}
          filteringMethod={filteringMethod}
          setFilteringMethod={setFilteringMethod}
          numberOfLatestSessions={numberOfLatestSessions}
          setNumberOfLatestSessions={setNumberOfLatestSessions}
          rangeFiltering={rangeFiltering}
          setRangeFiletering={setRangeFiletering}
          handleDatesChange={handleDatesChange}
          filterDate={filterDate}
          focusedInput={focusedInput}
          setFocusedInput={setFocusedInput}
          handleIsOutsideRange={handleIsOutsideRange}
          disabledMetrics={disabledMetrics}
          setDisabledMetrics={setDisabledMetrics}
          maxMinAvg={maxMinAvg}
          setMaxMinAvg={setMaxMinAvg}
          loggedUserData={loggedUserData}
          isLoading={isLoading}
          handleTagSelectedForFilter={handleTagSelectedForFilter}
          filteringByTags={filteringByTags}
          uniqueArrayOfTags={uniqueArrayOfTags}
          selectedTags={selectedTags}
          handleTagClick={handleTagClick}
          handleTagClear={handleTagClear}
          columns={columns}
          selectedMetricsForToggleState={selectedMetricsForToggleState}
          setSelectedMetricsForToggleState={setSelectedMetricsForToggleState}
          appearanceSelected={appearanceSelected}
          setAppearanceSelected={setAppearanceSelected}
          updateOverviewMetricsAndAppearanceLayout={
            updateOverviewMetricsAndAppearanceLayout
          }
          tagsSearch={tagsSearch}
          setTagsSearch={setTagsSearch}
          renderDay={renderDay}
        />
      </div>

      {overviewMetricData
        .filter(
          (item) =>
            item.data.length > 0 && !disabledMetrics.includes(item.metric)
        )
        .map((metric) => (
          <AthleteOverviewChart
            chartTitle={metric.metric}
            chartTittleToggled={metric.toggledMetric}
            chartData={metric.data}
            isMetric={metric.isMetric}
            primaryKey={metric.primaryKey}
            primaryKeyToggled={metric.primaryToggleKey}
            secondaryKeys={metric.secondaryKeys}
            bilateral={metric.bilateral}
            hasToggler={metric.toggleable}
            togglerKeys={metric.togglerKeys}
            tooltip={metric.tooltip}
            tooltipToggled={metric.tooltipToggled}
            chartAxisValueLabel={metric.chartValueAxisLabel}
            chartAxisValueLabelToggled={metric.chartValueAxisLabelToggled}
            isLoading={isLoading}
            chartType={metric.chartType}
            xAxisKey={metric.xAxisKey}
            handleChartElementClick={metric.handleElementClick}
            activityListForSelection={metric.activityListForSelection}
            ChartCustomTooltip={metric.customTooltip}
            hasSideToggler={metric.hasSideToggler}
            tooltipLeft={metric.tooltipLeft}
            tooltipRight={metric.tooltipRight}
            tooltipValue={metric.tooltipValue}
            maxMinAvg={maxMinAvg}
            measurementUnit={metric.measurementUnit}
            selectedTags={selectedTags}
            handleTagClick={handleTagClick}
            usingLatestSession={filteringMethod.latestSessions}
          />
        ))}
      <PlayerActivityDetails
        closeModal={closeModal}
        sessionId={selectedSessionId}
        fromPlayerProfile
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: selectUserData(state),
  athlete: selectAthlete(state),
  user: selectUser(state),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getAthleteHistoricalGait,
      getAthleteHistoricalLoad,
      getAthleteHistoricalGroundContact,
      getAthleteHistoricalRawAggSessions,
      getSessionList,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(AthleteOverview2);

[
  { id: 1, name: "Sprint" },
  { id: 2, name: "Jog" },
  { id: 3, name: "Walk" },
  { id: 4, name: "Double Leg Countermovement jump" },
  { id: 5, name: "Double Leg Drop Jump" },
  { id: 9, name: "Double Leg Squat Jump" },
  { id: 10, name: "Double Leg Repeated Hops" },
  { id: 11, name: "Double Leg Depth Jump" },
  { id: 14, name: "Single Leg Countermovement Jump" },
  { id: 15, name: "Single Leg Squat Jump" },
  { id: 16, name: "Single Leg Drop Jump" },
  { id: 17, name: "Single Leg Repeated Hops" },
  { id: 18, name: "Single Leg Depth Jump" },
  { id: 21, name: "Other" },
  { id: 22, name: "Isometric Calf Test " },
  { id: 35, name: "Bench press" },
  { id: 36, name: "Pull-up" },
  { id: 37, name: "Military press" },
  { id: 38, name: "Squat" },
  { id: 39, name: "Deadlift" },
  { id: 40, name: "Leg-press" },
  { id: 41, name: "Quiet Stance" },
  { id: 42, name: "Single Leg Stance" },
  { id: 43, name: "Agility" },
  { id: 44, name: "Free Run" },
];
